module.exports = __webpack_public_path__ + "img/mt4-icon3.d13a5a4.png";